
import React from 'react';
import PropTypes from 'prop-types';
import { LinkWrapper, ErrorSection, ExternalLink, NonAuthenticatedPageWall } from 'shared';
import local from 'services/localization/local';
import { externalUrls, appNames, localStoragePaths } from 'services/constants';
import PrivacyPolicyEulaSection from 'app/privacy-policy-eula/PrivacyPolicyEulaSection';
import RegisterForm from './RegisterForm';
import './Register.scss';
import RegisterStepHeader from './RegisterStepHeader';
import RegisterRightCardCovid from './RegisterRightCardCovid';
import RegisterRightCardDash from './RegisterRightCardDash';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import { getQueryStringParams } from 'services/url-service';

class Register extends React.Component {
  render() {
    const { registering, errorMessage, handleSubmit } = this.props;
    const navAction = <LinkWrapper id='already-have-account-sign-in-nav' className='button gray' to='/'>{local.linkSignIn}</LinkWrapper>;

    const query = getQueryStringParams(location);
    var app = query.app;
    if (app != undefined) {
      localStorage.setItem(localStoragePaths.app, app);
    } else {
      app = localStorage.getItem(localStoragePaths.app, app);
    }
    const content = local.nonAuthWallPage;
    let header = <h2>{content.header}</h2>;
    let subhead = <p>{content.subheadMember}</p>;
    let step;
    let registerSignUp = local.registerSignupMember;
    let registerRightCard;
    let isFromProvider = false;
    let registerAlreadyHaveAccount = local.registerAlreadyHaveAccount;
    let buttonNameText = local.formSignInJoin;
    let signInUrl = '/';

    switch (app) {
      case appNames.covid:
        subhead = <p>{content.subheadCovid}</p>;
        step = <RegisterStepHeader></RegisterStepHeader>;
        registerSignUp = local.registerSignupCovid;
        registerRightCard = <RegisterRightCardCovid></RegisterRightCardCovid>;
        break;
      case appNames.dash:
        subhead = <p>{content.subheadDash}</p>;
        step = <RegisterStepHeader></RegisterStepHeader>;
        registerSignUp = local.registerSignupDash;
        registerRightCard = <RegisterRightCardDash></RegisterRightCardDash>;
        break;
      case appNames.provider:
        isFromProvider = true;
        registerSignUp = local.registerSignupMember;
        registerAlreadyHaveAccount = local.registerAlreadyHaveCalciumAccount;
        buttonNameText = local.formCreateAccount;
        signInUrl = 'signin?app=provider';
        break;
    }

    let privacyPolicySection = <PrivacyPolicyEulaSection buttonNameText={buttonNameText} />;

    return (
      <div>
        
          <div>
            <Header></Header>
          </div>
        <div className='d-flex signin-section'>
          <div className='flex-fill'>
            <div id={'signIn-form'}>
              <NonAuthenticatedPageWall id='register' className="signin-content" titleTabText={local.register} navAction={navAction}>
                {!isFromProvider &&
                  <header>
                    <h2>{content.header}</h2>
                    {subhead}
                    {step}
                  </header>}
                <div className='col-12 '>
                  {isFromProvider &&
                    <div><h3 className='mb-0'>{content.headerProvider}</h3>
                      <p>{content.subheadProvider}</p>
                    </div>}
                  <div className="">
                    <div className=''>
                      <h4>{registerSignUp}</h4>
                      <ErrorSection>{errorMessage}</ErrorSection>
                      <RegisterForm onSubmit={handleSubmit} registering={registering} privacyPolicySection={privacyPolicySection} isFromProvider={isFromProvider} />
                      <div className='secondary-links'>
                        {!isFromProvider && <small>{local.formatString(local.registerLearnMore, (<ExternalLink id="register-learn-more" openNewTab href={externalUrls.hcAbout}>{local.linkLearnMore}</ExternalLink>))}</small>}
                        <br />
                        <small>{registerAlreadyHaveAccount} <LinkWrapper id='already-have-account-sign-in' to={signInUrl}>{local.linkSignIn}</LinkWrapper></small>
                      </div>
                    </div>
                    {registerRightCard}
                  </div>
                </div>
              </NonAuthenticatedPageWall>
            </div>
          </div>
          <div className='flex-fill image-section'>
            <img src="/static/images/logo-white.png" />
          </div>
        </div>
        <Footer></Footer>
      </div>
    );
  }
}

Register.displayName = 'Register';
Register.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  registering: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string
};

export default Register;

// import React from 'react';
// import PropTypes from 'prop-types';
// import { LinkWrapper, ErrorSection, ExternalLink, NonAuthenticatedPageWall } from 'shared';
// import local from 'services/localization/local';
// import { externalUrls, appNames, localStoragePaths } from 'services/constants';
// import PrivacyPolicyEulaSection from 'app/privacy-policy-eula/PrivacyPolicyEulaSection';
// import RegisterForm from './RegisterForm';
// import './Register.scss';
// import RegisterStepHeader from './RegisterStepHeader';
// import RegisterRightCardCovid from './RegisterRightCardCovid';
// import RegisterRightCardDash from './RegisterRightCardDash';
// import Header from '../../components/header/Header';
// import Footer from '../../components/footer/Footer';
// import { getQueryStringParams } from 'services/url-service';


// class Register extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       successMessage: '',
//       errorMessage: ''
//     };
//   }

//   setSuccessMessage = (message) => {
//     console.log("SUCCESS:", message);
//     this.setState({
//       successMessage: message,
//       errorMessage: ''
//     });
//   };

//   setErrorMessage = (message) => {
//     console.error("ERROR:", message);
//     this.setState({
//       errorMessage: message,
//       successMessage: ''
//     });
//   };

//   render() {
//     const { registering, handleSubmit } = this.props;
//     const { errorMessage, successMessage } = this.state;
//     const navAction = <LinkWrapper id='already-have-account-sign-in-nav' className='button gray' to='/'>{local.linkSignIn}</LinkWrapper>;

//     const query = getQueryStringParams(location);
//     var app = query.app;
//     if (app != undefined) {
//       localStorage.setItem(localStoragePaths.app, app);
//     } else {
//       app = localStorage.getItem(localStoragePaths.app, app);
//     }
//     const content = local.nonAuthWallPage;
//     let header = <h2>{content.header}</h2>;
//     let subhead = <p>{content.subheadMember}</p>;
//     let step;
//     let registerSignUp = local.registerSignupMember;
//     let registerRightCard;
//     let isFromProvider = false;
//     let registerAlreadyHaveAccount = local.registerAlreadyHaveAccount;
//     let buttonNameText = local.formSignInJoin;
//     let signInUrl = '/';

//     switch (app) {
//       case appNames.covid:
//         subhead = <p>{content.subheadCovid}</p>;
//         step = <RegisterStepHeader></RegisterStepHeader>;
//         registerSignUp = local.registerSignupCovid;
//         registerRightCard = <RegisterRightCardCovid></RegisterRightCardCovid>;
//         break;
//       case appNames.dash:
//         subhead = <p>{content.subheadDash}</p>;
//         step = <RegisterStepHeader></RegisterStepHeader>;
//         registerSignUp = local.registerSignupDash;
//         registerRightCard = <RegisterRightCardDash></RegisterRightCardDash>;
//         break;
//       case appNames.provider:
//         isFromProvider = true;
//         registerSignUp = local.registerSignupMember;
//         registerAlreadyHaveAccount = local.registerAlreadyHaveCalciumAccount;
//         buttonNameText = local.formCreateAccount;
//         signInUrl = 'signin?app=provider';
//         break;
//     }
//     let privacyPolicySection = <PrivacyPolicyEulaSection buttonNameText={buttonNameText} />;

//     return (
//       <div className='register-form-container'>
//         <div>
//           <Header isSignIn></Header>
//         </div>
//         <div className="register-inner-container">
//           <div className='new-inner-wrapper'>
//             <div className='new-registe-wrapper'>
//               <NonAuthenticatedPageWall id='' className="" titleTabText={local.register} navAction={navAction}>
//                 <header className='header-container'>
//                   <h2>{content.header}</h2>
//                   {subhead}
//                   {step}
//                 </header>
//                 <div className='register-form-inner-container'>

//                   {/* {!isFromProvider &&
//                     <div className='header-content mb-2'>
//                       <h3 >{content.headerProvider}</h3>
//                       <p>{content.subheadProvider}</p>
//                     </div>} */}
//                   <div className="register-form--inner-wrapper">
//                     {/* {!isFromProvider && <h4>{registerSignUp}</h4>} */}
//                     <ErrorSection>
//                       {successMessage && <div className="alert alert-success">{successMessage}</div>}
//                       {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
//                     </ErrorSection>
//                     <RegisterForm
//                       onSubmit={this.handleSubmit}
//                       registering={registering}
//                       privacyPolicySection={privacyPolicySection}
//                       isFromProvider={isFromProvider}
//                       onSuccessMessage={this.setSuccessMessage}
//                       onErrorMessage={this.setErrorMessage} />
//                     <div className='secondary-links'>
//                       {!isFromProvider && <small>{local.formatString(local.registerLearnMore, (<ExternalLink id="register-learn-more" openNewTab href={externalUrls.hcAbout}>{local.linkLearnMore}</ExternalLink>))}</small>}
//                       <br />
//                       <small>{registerAlreadyHaveAccount} <LinkWrapper id='already-have-account-sign-in' to={signInUrl}>{local.linkSignIn}</LinkWrapper></small>
//                     </div>
//                   </div>
//                 </div>
//               </NonAuthenticatedPageWall>
//             </div>
//             <div className='form-image-container'>
//               <div className='image-container'>
//                 <img src="/static/images/logo-white.png" />
//               </div>
//             </div>
//           </div>

//         </div>
//         <Footer></Footer>
//       </div>
//     );
//   }
// }

// Register.displayName = 'Register';
// Register.propTypes = {
//   handleSubmit: PropTypes.func.isRequired,
//   registering: PropTypes.bool.isRequired,
//   errorMessage: PropTypes.string
// };

// export default Register;


// import React, { Component } from 'react';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { GoDot, GoDotFill } from "react-icons/go";
// import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
// import { TfiControlBackward } from "react-icons/tfi";
// import './Register.scss';

// class Register extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       formData: {
//         firstName: '',
//         lastName: '',
//         mobile: '',
//         email: '',
//         password: '',
//         companyName: '',
//         npi: '',
//         address: '',
//         zipcode: '',
//         city: '',
//         state: '',
//         country: ''
//       },
//       passwordRules: {
//         minLength: false,
//         uppercase: false,
//         specialChar: false,
//         alphanumeric: false
//       },
//       formStep: 1,
//       isPasswordFocused: false,
//       showPasswordError: false,
//       showPassword: false,
//       mobileCountry: 'us'
//     };
//   }

//   handleChange = (e) => {
//     const { name, value } = e.target;
//     const { formData, mobileCountry } = this.state;

//     if (name === 'password') {
//       const cleanValue = value.replace(/\s/g, '');
//       const rules = {
//         minLength: cleanValue.length >= 8,
//         uppercase: /[A-Z]/.test(cleanValue),
//         specialChar: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(cleanValue),
//         alphanumeric: /[A-Za-z]/.test(cleanValue) && /\d/.test(cleanValue)
//       };
//       this.setState({
//         formData: { ...formData, password: cleanValue },
//         passwordRules: rules
//       });
//     } else if (name === 'zipcode') {
//       this.setState({
//         formData: { ...formData, zipcode: value }
//       }, () => {
//         if (mobileCountry === 'us' && /^\d{5}$/.test(value)) {
//           this.fetchCityStateFromZip(value);
//         } else {
//           this.setState({
//             formData: {
//               ...this.state.formData,
//               city: '',
//               state: '',
//               country: ''
//             }
//           });
//         }
//       });
//     } else {
//       this.setState({
//         formData: { ...formData, [name]: value }
//       });
//     }
//   };

//   fetchCityStateFromZip = async (zip) => {
//     try {
//       const res = await fetch(`https://api.zippopotam.us/us/${zip}`);
//       if (!res.ok) throw new Error('Invalid ZIP');
//       const data = await res.json();
//       const place = data.places?.[0];
//       if (place) {
//         this.setState({
//           formData: {
//             ...this.state.formData,
//             city: place['place name'],
//             state: place['state abbreviation'],
//             country: data.country
//           }
//         });
//       }
//     } catch (err) {
//       this.setState({
//         formData: {
//           ...this.state.formData,
//           city: '',
//           state: '',
//           country: ''
//         }
//       });
//     }
//   };

//   handlePhoneChange = (value, data) => {
//     this.setState({
//       formData: { ...this.state.formData, mobile: value },
//       mobileCountry: data.countryCode
//     });
//   };

//   handleContinue = () => {
//     const { firstName, lastName, email, password } = this.state.formData;
//     const { minLength, uppercase, specialChar } = this.state.passwordRules;
//     if (firstName && lastName && email && password && minLength && uppercase && specialChar) {
//       this.setState({ formStep: 2, showPasswordError: false });
//     } else {
//       this.setState({ showPasswordError: true });
//     }
//   };

//   handlePrevious = () => {
//     this.setState({ formStep: 1, showPasswordError: false });
//   };

//   handleSubmit = (e) => {
//     e.preventDefault();
//     const { minLength, uppercase, specialChar, alphanumeric } = this.state.passwordRules;
//     if (!minLength || !uppercase || !specialChar || !alphanumeric) {
//       this.setState({ showPasswordError: true });
//       return;
//     }
//     console.log('Submitted Data:', this.state.formData);
//   };


//   render() {
//     const { formData, passwordRules, formStep, showPassword, showPasswordError, isPasswordFocused, mobileCountry } = this.state;
//     const allRulesPassed = Object.values(passwordRules).every(Boolean);

//     return (
//       <div className="register-container">
//         <div className="form-side">
//           <form className="register-form" onSubmit={this.handleSubmit}>
//             {formStep === 1 && (
//               <div className="register-form-container">
//                 <h2 className='form-head-text'>Contact details</h2>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>First Name <span>*</span></label>
//                     <input type="text" name="firstName" value={formData.firstName} onChange={this.handleChange} required />
//                   </div>
//                   <div className="form-field">
//                     <label>Last Name <span>*</span></label>
//                     <input type="text" name="lastName" value={formData.lastName} onChange={this.handleChange} required />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field full">
//                     <label>Email <span>*</span></label>
//                     <input type="email" name="email" value={formData.email} onChange={this.handleChange} required />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>Password <span>*</span></label>
//                     <div className="password-input-wrapper">
//                       <input
//                         type={showPassword ? 'text' : 'password'}
//                         name="password"
//                         value={formData.password}
//                         onChange={this.handleChange}
//                         onFocus={() => this.setState({ isPasswordFocused: true, showPasswordError: false })}
//                         onBlur={() => {
//                           const { minLength, uppercase, specialChar } = passwordRules;
//                           this.setState({
//                             isPasswordFocused: false,
//                             showPasswordError: !(minLength && uppercase && specialChar)
//                           });
//                         }}
//                         required
//                       />
//                       <span className="toggle-eye" onClick={() => this.setState({ showPassword: !showPassword })}>
//                         {showPassword ? <IoEyeOutline /> : <IoEyeOffOutline />}
//                       </span>
//                     </div>
//                     {isPasswordFocused && (
//                       <ul className="password-rules">
//                         <li style={{ color: passwordRules.minLength ? 'green' : 'red' }}>{passwordRules.minLength ? <GoDotFill /> : <GoDot />} Minimum 8 characters</li>
//                         <li style={{ color: passwordRules.uppercase ? 'green' : 'red' }}>{passwordRules.uppercase ? <GoDotFill /> : <GoDot />} At least one uppercase letter</li>
//                         <li style={{ color: passwordRules.specialChar ? 'green' : 'red' }}>{passwordRules.specialChar ? <GoDotFill /> : <GoDot />} At least one special character</li>
//                         <li style={{ color: passwordRules.alphanumeric ? 'green' : 'red' }}>{passwordRules.alphanumeric ? <GoDotFill /> : <GoDot />} Contains letters and numbers</li>
//                       </ul>
//                     )}
//                     {showPasswordError && <span className="error-text">Password must meet the conditions above.</span>}
//                   </div>
//                 </div>
//                 <div className='continue-button'>
//                   <button type="button" className="continue-btn" onClick={this.handleContinue}>Continue</button>
//                   <p className='login-quote'>Already have an account? <span>Login</span></p>
//                 </div>
//               </div>
//             )}

//             {formStep === 2 && (
//               <div className="register-form-step-2">
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>Organisation Name *</label>
//                     <input type="text" name="companyName" value={formData.companyName} onChange={this.handleChange} required />
//                   </div>
//                   <div className="form-field">
//                     <label>Mobile Number *</label>
//                     <PhoneInput
//                       country={'us'}
//                       value={formData.mobile}
//                       onChange={this.handlePhoneChange}
//                       inputProps={{ name: 'mobile', required: true }}
//                     />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>NPI Number</label>
//                     <input type="text" name="npi" value={formData.npi} onChange={this.handleChange} />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>Address *</label>
//                     <textarea name="address" value={formData.address} onChange={this.handleChange} required />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>Zip Code *</label>
//                     <input name="zipcode" value={formData.zipcode} onChange={this.handleChange} required />
//                   </div>
//                   <div className="form-field">
//                     <label>City *</label>
//                     <input name="city" value={formData.city} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
//                   </div>
//                 </div>
//                 <div className="form-group">
//                   <div className="form-field">
//                     <label>State *</label>
//                     <input name="state" value={formData.state} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
//                   </div>
//                   <div className="form-field">
//                     <label>Country *</label>
//                     <input name="country" value={formData.country} onChange={this.handleChange} readOnly={mobileCountry === 'us'} />
//                   </div>
//                 </div>
//                 <button type="submit" disabled={!allRulesPassed}>Register</button>
//                 <button type="button" onClick={this.handlePrevious}><TfiControlBackward /> Previous</button>
//               </div>
//             )}
//           </form>
//         </div>
//         <div className='right-container'>
//           <div className="image-side">
//             <img src="/static/images/logo-white.png" alt="Healthcare" className="spin-image" />
//             <img />
//           </div>
//           <div className='register-quotes'>
//             <h2 className="typing-animatio">Welcome to Calcium !</h2>
//             <h3>Your Health Journey starts here — with care, compassion, and connection.</h3>
//             <h6>
//               Thank you for choosing a smarter way to manage Patients. <br />
//               Unified access to health records. Safe and secure health data with a HIPAA-compliant platform.
//             </h6>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default Register;
